<div class="p-6 max-w-4xl mx-auto bg-white min-h-[90vh] rounded-md" *transloco="let t">
  <!-- Navigation Tabs -->
  <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" class="profile-tabset">
    <nz-tab [nzTitle]="t('profile')">
      <!-- Profile Content -->
      <div class="mt-2">
        <!-- Profile Banner -->
        <div class="bg-gradient-to-r from-mbaza-primary to-mbaza-secondary rounded-sm p-6 mb-4">
          <div class="flex items-center gap-8">
            <app-mb-image-upload [placeholder]="t('uploadProfilePicture')" [maxSize]="5"
              (imageSelected)="onImageSelected($event)" (fileSelected)="onFileSelected($event)"
              [imageUrl]="profilePicturePreview || ''" />
            <div class="text-white flex flex-col gap-1">
              <span class="text-3xl font-extrabold text-white!" *ngIf="user$ | async as user">
                {{ user.firstName }} {{ user.lastName }}
              </span>
              <span class="opacity-90 font-extralight" *ngIf="user$ | async as user">
                {{ t("occupation") }}: {{ user.occupation }}
              </span>
              <span class="opacity-90 font-extralight" *ngIf="user$ | async as user">
                {{ t("organization") }}: {{ user.organizationName || "N/A" }}
              </span>
            </div>
          </div>
        </div>
        <form [formGroup]="profileForm">
          <!-- Edit Personal Info Section -->
          <div class="py-6 mb-2">
            <div class="flex flex-col gap-1 mb-4">
              <span class="text-lg font-extrabold">{{
                t("editPersonalInfo")
                }}</span>
              <span class="text-mbaza-text-secondary font-extralight text-xs italic">
                {{ t("editPersonalInfoDescription") }}
              </span>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <app-mb-input [placeholder]="t('form.placeholder.firstName')" formControlName="firstName"
                [prefixLabel]="t('form.label.firstName')" type="text" [errorMessage]="zodErrors['firstName']"
                [hasError]="!!zodErrors['firstName']" />
              <app-mb-input [placeholder]="t('form.placeholder.lastName')" formControlName="lastName"
                [prefixLabel]="t('form.label.lastName')" type="text" [errorMessage]="zodErrors['lastName']"
                [hasError]="!!zodErrors['lastName']" />
              <app-mb-input [placeholder]="t('form.placeholder.email')" formControlName="email"
                [prefixLabel]="t('form.label.email')" type="text" [errorMessage]="zodErrors['email']"
                [hasError]="!!zodErrors['email']" [disabled]="true" />
              <app-mb-input [placeholder]="t('form.placeholder.phoneNumber')" formControlName="phone"
                [prefixLabel]="t('form.label.phoneNumber')" type="phone" [errorMessage]="zodErrors['phone']"
                [hasError]="!!zodErrors['phone']" [disabled]="true" />
            </div>

            <!-- Save Changes Button for Personal Info -->
            <div class="flex justify-end mt-4">
              <app-mb-button [label]="t('saveChanges')" [type]="'secondary'" (click)="saveChanges()"
                [loading]="isLoading" [disabled]="(hasChanges$ | async) !== true"></app-mb-button>
            </div>
          </div>

          <!-- Edit Password Section -->
          <div class="mb-6 border-t border-gray-200 pt-6">
            <div class="flex flex-col gap-1 mb-4">
              <span class="text-lg font-extrabold">{{
                t("changePassword")
                }}</span>
              <span class="text-mbaza-text-secondary font-extralight italic text-xs">
                {{ t("changePasswordDescription") }}
              </span>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <app-mb-input formControlName="oldPassword" [placeholder]="t('enterCurrentPassword')"
                [prefixLabel]="t('currentPassword')" type="password" [errorMessage]="zodErrors['oldPassword']"
                [hasError]="!!zodErrors['oldPassword']" />
              <div class="md:col-start-1">
                <app-mb-input formControlName="newPassword" [placeholder]="t('enterNewPassword')"
                  [prefixLabel]="t('newPassword')" type="password" [errorMessage]="zodErrors['newPassword']"
                  [hasError]="!!zodErrors['newPassword']" />
              </div>
              <app-mb-input formControlName="confirmPassword" [placeholder]="t('enterConfirmPassword')"
                [prefixLabel]="t('confirmPassword')" type="password" [errorMessage]="zodErrors['confirmPassword']"
                [hasError]="!!zodErrors['confirmPassword']" />
            </div>

            <!-- Change Password Button -->
            <div class="flex justify-end mt-4">
              <app-mb-button [label]="t('changePassword')" [type]="'secondary'" (click)="changePassword()"
                [loading]="isPasswordLoading" [disabled]="!hasPasswordChange"></app-mb-button>
            </div>
          </div>
        </form>
      </div>
      <app-mb-success-modal [(isVisible)]="isSuccessModalVisible" [message]="successMessage"
        (isVisibleChange)="onSuccessModalClose()" />
    </nz-tab>

    <nz-tab [nzTitle]="t('systemConfiguration.label')">
      <!-- System Configuration Content -->
      <div class="mt-2">
        <!-- Notification Preferences -->
        <div class="py-6 mb-2">
          <div class="flex flex-col gap-1 mb-4">
            <span class="text-xl font-semibold">
              {{ t("systemConfiguration.title") }}
            </span>
            <span class="text-mbaza-text-secondary font-extralight text-xs italic">
              {{ t("systemConfiguration.description") }}
            </span>
          </div>

          <div class="space-y-4 border border-mbaza-gray-dark p-6 rounded-sm">
            <!--            <div class="flex items-center justify-between">-->
            <!--              <span class="text-gray-700">WhatsApp</span>-->
            <!--              <app-mb-switch-->
            <!--                [checked]="notificationPrefs.WHATSAPP"-->
            <!--                (change)="onNotificationChange($event, 'WHATSAPP')"-->
            <!--              ></app-mb-switch>-->
            <!--            </div>-->
            <div class="flex items-center justify-between">
              <span class="text-gray-700">SMS</span>
              <app-mb-switch [checked]="notificationPrefs.SMS"
                (change)="onNotificationChange($event, 'SMS')"></app-mb-switch>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-gray-700">Email</span>
              <app-mb-switch [checked]="notificationPrefs.EMAIL"
                (change)="onNotificationChange($event, 'EMAIL')"></app-mb-switch>
            </div>
          </div>
        </div>
      </div>
    </nz-tab>
  </nz-tabset>
</div>